import { UserService } from './../../shared/user.service';
import { AngularFireAuth } from '@angular/fire/auth';
import { Component, OnInit } from '@angular/core';
import { auth } from 'firebase/app';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

interface IEvent {
  event: 'signedup';
}
declare let dataLayer: IEvent[];
declare let tracker: any; // KARTEタグ

@Component({
  selector: 'app-signup-page',
  templateUrl: './signup-page.component.html',
  styleUrls: ['./signup-page.component.scss'],
})
export class SignupPageComponent implements OnInit {
  backUrl: string;
  finished = false;
  form: FormGroup;
  errorMessage = '';
  fromEntry = false;
  fromVote = false;

  constructor(
    private auth: AngularFireAuth,
    private users: UserService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.form = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.email]),
      password: new FormControl('', [Validators.required, Validators.minLength(8)]),
    });

    const url = this.route.snapshot.queryParamMap.get('url');
    //console.log("remember url" + url);
    if (url != null) {
      this.backUrl = url;
      if (url.match(/entry/)) {
        console.log('fromEntry!');
        this.fromEntry = true;
      }
      if (url.match(/vote/)) {
        this.fromVote = true;
      }
    } else {
      this.backUrl = '';
    }
    //this.backUrl = url ? url : '';
  }

  async doSignup() {
    console.log('doSignup');
    if (this.form.invalid) {
      Object.keys(this.form.controls).forEach((key) => {
        this.form.get(key).markAsTouched({ onlySelf: true });
        console.log(this.form.get(key).errors);
      });
      console.log('invalid');
      return;
    }
    const data = this.form.value;
    const user = this.auth.auth.currentUser;
    try {
      if (user) {
        if (user.isAnonymous) {
          const credential = auth.EmailAuthProvider.credential(data['email'], data['password']);
          await user.linkAndRetrieveDataWithCredential(credential);
        } else {
          console.log(user);
        }
      } else {
        const newuser = await this.auth.auth.createUserAndRetrieveDataWithEmailAndPassword(
          data['email'],
          data['password']
        );
      }
      this.navigateNext();
      // this.finished = true;
    } catch (e) {
      this.showErrorMessage(e);
    }
  }

  async signupWithGoogle() {
    const user = this.auth.auth.currentUser;
    try {
      if (user) {
        if (user.isAnonymous) {
          await user.linkWithPopup(new auth.GoogleAuthProvider());
        }
      } else {
        const newUser = await this.auth.auth.signInWithPopup(new auth.GoogleAuthProvider());
        console.log(newUser);
      }
      this.navigateNext();
    } catch (e) {
      this.showErrorMessage(e);
    }
  }

  async signupWithFacebook() {
    const user = this.auth.auth.currentUser;
    try {
      if (user) {
        if (user.isAnonymous) {
          await user.linkWithPopup(new auth.FacebookAuthProvider());
        }
      } else {
        const newUser = await this.auth.auth.signInWithRedirect(new auth.FacebookAuthProvider());
        console.log(newUser);
      }
      this.navigateNext();
    } catch (e) {
      this.showErrorMessage(e);
    }
  }

  get email() {
    return this.form.get('email');
  }

  get password() {
    return this.form.get('password');
  }

  private async navigateNext() {
    // KARTEタグ: 新規登録
    tracker.track('signup', {});

    dataLayer.push({
      event: 'signedup',
    });
    const options = { queryParams: { v: 'signedup' } };
    if (await this.users.getProfile()) {
      this.router.navigate(['/'], options);
    } else {
      this.router.navigate(['/profile/step1'], options);
    }
  }

  private showErrorMessage(e) {
    console.log(e);
    let errorMessage = '登録に失敗しました';

    if (e.code) {
      switch (e.code) {
        case 'auth/account-exists-with-different-credential':
          errorMessage = 'メールアドレスが他のアカウントに登録されています';
          break;

        case 'auth/email-already-in-use':
          errorMessage = 'メールアドレスが他のアカウントに登録されています';
          break;

        case 'auth/credential-already-in-use':
          errorMessage = '既に登録済みです';
          break;

        default:
          break;
      }
    }

    this.errorMessage = errorMessage;
  }
}
